import { render, staticRenderFns } from "./Top.vue?vue&type=template&id=4ce12819&scoped=true&lang=pug&"
import script from "./Top.vue?vue&type=script&lang=coffee&"
export * from "./Top.vue?vue&type=script&lang=coffee&"
import style0 from "./Top.vue?vue&type=style&index=0&id=4ce12819&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce12819",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
